import config from '@/config';
import { FallbackProps } from 'react-error-boundary';

export function ErrorBoundaryFallbackRender({ error }: FallbackProps) {
  return (
    <div className="bg-red-foreground text-red dark:bg-background rounded border p-4">
      <h2 className="mb-2 text-lg font-bold">Oops, something went wrong!</h2>
      <p>{error instanceof Error ? error.message : 'Unknown error'}</p>

      {!config.production && (
        <pre className="mt-2 text-xs whitespace-pre-wrap">
          {error instanceof Error ? error.stack : 'Unknown stack'}
        </pre>
      )}
    </div>
  );
}
